import { render, staticRenderFns } from "./flowDetail.vue?vue&type=template&id=ea30c454&scoped=true&"
import script from "./flowDetail.vue?vue&type=script&lang=js&"
export * from "./flowDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea30c454",
  null
  
)

export default component.exports